var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTextmark = function SvgTextmark(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66669 8.16663H16.3334V10.8333H15.6667V8.83329H12.3334V16.1666H14.3334V16.8333H9.33335V16.1666H11.6667V8.83329H8.33335V10.8333H7.66669V8.16663Z",
    fill: "var(--iconColor, currentColor)",
    stroke: "var(--iconColor, currentColor)",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.38794,
    y: 4.9231,
    width: 2,
    height: 15.7814,
    fill: "var(--iconColor, currentColor)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.38794,
    y: 20.0573,
    width: 4.43578,
    height: 2,
    fill: "var(--iconColor, currentColor)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1.38794,
    y: 2.9231,
    width: 4.43578,
    height: 2,
    fill: "var(--iconColor, currentColor)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 20.3879,
    y: 4.9231,
    width: 2,
    height: 15.7814,
    fill: "var(--iconColor, currentColor)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 17.9521,
    y: 20.067,
    width: 4.43578,
    height: 2,
    fill: "var(--iconColor, currentColor)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 17.9521,
    y: 2.93298,
    width: 4.43578,
    height: 2,
    fill: "var(--iconColor, currentColor)"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTextmark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "textmark.49658d64bd0730dd46782de0055ecf96.svg";